/**
 * New mobile navigation.js.
 *
 */

const mobileNav = document.querySelector('.new-mobile-header');
if(mobileNav) {
    //Header search toggle
    const searchButton = mobileNav.querySelector('.search-button')
    searchButton.addEventListener("click", (event) => {
        if(hamburger.querySelector('.hamburger').classList.contains('open') ){
            hamburger.querySelector('.hamburger').classList.remove('open')
            hamburger.classList.remove("open");
            document.querySelector('body').classList.remove('menu-open');
            mobileNav.querySelector('.new-mobile-nav__container').classList.remove("open");
            setTimeout(function() {
                searchButton.classList.add("open");
                mobileNav.querySelector('.c-search-form').classList.add("open");
            }, 400);
            return;
        }
        searchButton.classList.toggle("open");
        mobileNav.querySelector('.c-search-form').classList.toggle("open");
    });

    const hamburger = mobileNav.querySelector('.new-mobile-header__hamburger-wrapper')
    hamburger.addEventListener("click", (event) => {
        if(searchButton.classList.contains('open') ){
            searchButton.classList.remove('open')
            mobileNav.querySelector('.c-search-form').classList.remove("open");
            setTimeout(function() {
                document.querySelector('body').classList.toggle('menu-open');
                hamburger.querySelector('.hamburger').classList.toggle("open");
                hamburger.classList.toggle("open");
                mobileNav.querySelector('.new-mobile-nav__container').classList.toggle("open");
            }, 200);
            return;
        }
        document.querySelector('body').classList.toggle('menu-open');
        hamburger.querySelector('.hamburger').classList.toggle("open");
        hamburger.classList.toggle("open");
        mobileNav.querySelector('.new-mobile-nav__container').classList.toggle("open");
    });


    //main item submenu
    const mainItems = mobileNav.querySelectorAll('li.main-menu-item.menu-item-has-children a.main-inner');
    Array.from(mainItems).map(elem => {
        elem.addEventListener("click", (event) => {
            event.preventDefault();
            elem.parentElement.classList.add('active');
        })
    })

    //submenu back button
    const mobileBackButtons = mobileNav.querySelectorAll('.back-button');
    Array.from(mobileBackButtons).map(elem => {
        elem.addEventListener("click", (event) => {
            event.preventDefault();
            elem.closest('.main-menu-item').classList.remove('active');
            console.log(elem.closest('.main-menu-item'))
        })
    })

    //Item submenu toggle
    const submenuItems = mobileNav.querySelectorAll('.new-mobile-sub-menu-wrap .sub-menu-item.menu-item-has-children .sub-menu-title-wrapper .menu-arrow');
    jQuery('.new-mobile-main-nav__sec-lvl-sub-menu', mobileNav).slideUp();
    jQuery('.new-mobile-main-nav__third-lvl-sub-menu', mobileNav).slideUp();

    Array.from(submenuItems).map(elem => {
        elem.addEventListener("click", (event) => {
            elem.classList.toggle('open');
            elem.parentElement.querySelector('.menu-inner').classList.toggle('open');
            jQuery('.new-mobile-main-nav__sec-lvl-sub-menu', elem.parentElement.parentElement).slideToggle('slow');
        });
    })

    const secSubItems = mobileNav.querySelectorAll('.new-mobile-sub-menu-wrap .sec-lvl-sub-menu-item.menu-item-has-children .sec-lvl-menu-title-wrapper .menu-arrow');
    Array.from(secSubItems).map(elem => {
        elem.addEventListener("click", (event) => {
            elem.classList.toggle('open');
            jQuery('.new-mobile-main-nav__third-lvl-sub-menu', elem.parentElement.parentElement).slideToggle('slow');
        });
    })

}
